import { Box, Card, CardContent, Divider, Grid, Typography } from '@mui/material'
import TotalTransactionFeesPastChart from './TotalTransactionFeesPastChart'
import dayjs from 'dayjs'
import { useSearchParams } from 'react-router-dom'

export const TotalTransactionFees = ({ data }: { data: any }) => {
  const { __, __n } = useTranslator()
  const [searchParams] = useSearchParams()
  const monthParam = searchParams.get('month')
  const activeMonthIndex = monthParam ? dayjs(monthParam).month() + 1 : 0

  // const chartData = data ? Object.values(data).map((item: any) => item?.balance?.service_fee) : []

  const chartData = data
    ? Object.entries(data).reduce((acc: Record<string, { debt: number; collected: number, service_fee?: number }>, [key, value]) => {
        const v = value as { balance?: { debt?: number; collected?: number, service_fee?: number } }

        acc[`${key}`] = {
          debt: v.balance?.debt || 0,
          collected: v.balance?.collected || 0,
          service_fee: v.balance?.service_fee || 0,
        }

        return acc
      }, {})
    : {}

  return (
    <Card className='rounded-[16px]'>
      <CardContent className='p-6'>
        <div className='flex flex-col gap-2'>
          <div className='flex flex-row gap-2 items-center'>
            <Box className='rounded-[6px] bg-[#DFE3FD] p-2 flex items-center '>
              <i className='tabler-wallet text-[#3551F2]'></i>
            </Box>
            <Typography className='text-[18px] font-medium leading-[28px]'>{__('Total Transaction Fees')}</Typography>
          </div>
          <Typography className='text-[38px] font-medium leading-[56px]'>{__n(chartData?.[String(activeMonthIndex)]?.service_fee || 0, 'đ')}</Typography>
        </div>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 5 }}>
            <div className='flex justify-between items-center'>
              <div className='flex flex-row gap-2 items-center'>
                <i className='tabler-cash-banknote-off ' />
                <Typography className='text-[15px] font-medium leading-[22px]'>{__('Collected')}</Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>
                {__n(chartData?.[String(activeMonthIndex)]?.collected || 0, 'đ')}
              </Typography>
            </div>
          </Grid>
          <Divider orientation='vertical' flexItem className='mx-[24px]' />
          <Grid size={{ xs: 12, md: 5 }}>
            <div className='flex justify-between items-center'>
              <div className='flex flex-row gap-2 items-center'>
                <i className='tabler-cash-banknote-off ' />
                <Typography className='text-[15px] font-medium leading-[22px]'>{__('Debt')}</Typography>
              </div>
              <Typography className='text-[15px] font-medium leading-[22px]'>
                {__n(chartData?.[String(activeMonthIndex)]?.debt || 0, 'đ')}
              </Typography>
            </div>
          </Grid>
        </Grid>

        {/* Chart Total Transaction Fees In Past Month */}
        <TotalTransactionFeesPastChart className='h-[230px]' data={chartData} />
      </CardContent>
    </Card>
  )
}
